<template>
  <div>
    <!-- Autre façon de faire -->
    <div class="columns is-gapless is-vcentered is-border-bottom has-background-light is-minH50p is-marginless">
      <div class="column is-padding-left">
        <span class="is-size-6">{{ sourceUserTeam.length }} Vendeur(s)</span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <router-link
          class="button is-radiusless is-small is-light is-minH100 has-text-grey"
          :to="{name: 'UserCreate', query: {manager: sourceUser.pk, profil: 'seller'}}">
          <span class="icon"><i class="fal fa-user-plus"></i></span>
          <span>Créer un utilisateur</span>
        </router-link>
      </div>
      <div
        v-if="isAdmin"
        class="column is-narrow is-border-left is-self-stretched">
        <a
          @click="openUserSelection()"
          class="button is-radiusless is-small is-light is-minH100 has-text-grey">
          <span class="icon"><i class="fal fa-plus"></i></span>
          <span>Ajouter un membre</span>
        </a>
      </div>
    </div>
    <table
      v-if="sourceUserTeam && sourceUserTeam.length"
      class="table is-fullwidth has-actionsontd has-cells-vcentered is-last-fixed-medium">
      <thead class="">
        <tr class="is-size-6">
          <th>
            Membres
          </th>
          <th>
            Actions
          </th>
        </tr>
      </thead>
      <tbody class="is-size-6">
        <tr
          v-for="(user, i) in sourceUserTeam"
          :key="user.pk">
          <td class="is-cell-hoverable">
            <router-link
              :to="{name: 'UserVue', params: {id: user.pk}}"
              class="fullLink">
              <avatar
                class="is-margin-right-xsmall"
                :item="user"
                :i="i"></avatar>
              <span>{{ user.last_name }} {{ user.first_name }}</span>
            </router-link>
          </td>
          <td class="has-text-centered">
            <display-button-list
              :buttons="buttonList"
              :data="user">
            </display-button-list>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucun membre à afficher
    </div>
  </div>
</template>

<script>
import { Quickview } from '@/mixins'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'UserTeamList',
  mixins: [Quickview],
  props: {
    sourceUser: {
      type: Object
    },
    sourceUserTeam: {
      type: Array
    },
    propsTab: String
  },
  data () {
    return {
      selectedSeller: [],
      openMembre: false,
      tableRows: 8,
      users: [],
      buttonList: [
        {
          action: (id, data) => {
            this.removeSeller(data)
          },
          icon: 'fa-user-minus',
          text: 'Retirer de l\'équipe',
          display: (o) => {
            return this.isAdmin || this.isManager
          }
        },
        {
          routeName: 'UserEdit',
          icon: 'fa-user-edit',
          text: 'Modifier l\'utilisateur',
          display: (o) => {
            return this.isAdmin || this.isManager
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager']),
    ...mapState(['quickview'])
  },
  watch: {
    async quickview ({ mode, params, results }) {
      if (results && mode === 'USER_SELECTION') {
        for (let entitie of results.entities) {
          this.selectedSeller.push(entitie.pk)
        }
        await this.addUserInTeam()
        this.selectedSeller = []
      }
    }
  },
  methods: {
    /**
      * add selected user in user team
      */
    async addUserInTeam () {
      try {
        let team = await this.$api.addUsersInTeam(this.sourceUser.pk, this.selectedSeller)
        this.$emit('updateTeam', team.data)
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * prepare params for quickview
      * function in QuickviewMixin.js
      */
    async openUserSelection () {
      let params = {
        facets: {
          USER: [
            [`profil:seller`],
            [`pk:-${this.sourceUser.pk}`],
            ['manager:null']
          ]
        },
        mode: 'store'
      }
      this.openUserSelectionQuickview(params)
    },
    /**
      * get seller without manager
      */
    /**
      * confirmation before remove
      */
    confirmationRemove () {
      return this.$swal({
        title: 'Suppression',
        text: 'Êtes-vous sur de vouloir retirer cet utilisateur de l\'équipe ?',
        confirmButtonText: 'Retirer',
        focusConfirm: false
      })
    },
    /**
      * remove selected user from user team
      */
    async removeSeller (seller) {
      let result = await this.confirmationRemove()
      if (result.dismiss) return false // ON ne supprimme pas
      if (result) {
        let sellerPk = seller.pk
        let managerPk = this.sourceUser.pk
        let team = await this.$api.removeUsersFromTeam(managerPk, [sellerPk])
        this.$emit('updateTeam', team.data)
      }
    }
  }
}
</script>

<style></style>
